export default __webpack_public_path__ + "static/noi-2021-silver-medal-ba8329737e3785201657d66812bfd671.png";